var OCBView;!function(e){e[e.Order=0]="Order",e[e.Welcome=1]="Welcome",e[e.Total=2]="Total"}(OCBView||(OCBView={}));export{OCBView};
//# sourceMappingURL=types.js.map
